<template>
  <section class="pb-3">
    <section-title id="welcome">
      {{ $t("planning-unsigned-document") }} ({{ documents.length }})
    </section-title>

    <div
      class="document-list d-flex flex-wrap flex-row justify-content-between"
      v-if="documents.length"
    >
      <b-card
        class="mb-3 shadow"
        v-for="doc in documents.slice(0, displayDocNumber)"
        :key="doc.pk"
      >
        <b-media>
          <svgicon
            slot="aside"
            icon="invoice"
            width="48"
            height="48"
            color="#ddd"
          ></svgicon>
          {{ doc.typeDescription }}
        </b-media>
        <div slot="footer">
          <div class="d-flex flex-wrap button-group">
            <b-btn
              :href="doc.signUrl"
              target="_blank"
              variant="primary"
              size="sm"
              class="mr-3 mt-1 mb-1"
            >
              <svgicon icon="pencil" color="#ffffff" class="mr-1"></svgicon>
              {{ $t("documents-sign-btn") }}
            </b-btn>
            <b-btn
              class="mt-1 mb-1"
              @click="downloadDoc(doc.id, doc.typeDescription)"
              variant="primary"
              size="sm"
            >
              <svgicon icon="download" class="mr-1"></svgicon>
              {{ $t("document-management-download") }}
            </b-btn>
          </div>
        </div>
      </b-card>
    </div>
    <b-media v-if="isLoading && !documents.length" class="mb-3 text-center">
      <spinner height="128" width="128"></spinner>
    </b-media>
    <b-media v-if="!documents.length && !isLoading && !error">
      {{ $t("no-data") }}
    </b-media>
    <b-media
      v-if="error"
      v-html="$t('document-management-tax-receipt-data-error')"
    >
    </b-media>
    <div class="pb-5">
      <b-btn
        class="float-right"
        :disabled="displayDocNumber >= documents.length"
        @click="showMore()"
        variant="outline-primary"
      >
        {{ $t("documents-show-more-btn") }} ›
      </b-btn>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SectionTitle from "../../SectionTitle.vue";
import Spinner from "../../Helpers/Spinner/Spinner.vue";
import DownloadPdf from "../../Mixins/downloadPdf.js";
import DocumentService from "../../../services/document";

export default {
  components: {
    SectionTitle,
    Spinner
  },
  mixins: [DownloadPdf],
  data() {
    return {
      documents: [],
      totalDocuments: 2,
      displayDocNumber: 4,
      error: false
    };
  },
  computed: {
    ...mapGetters(["isLoading"])
  },
  created() {
    this.loadUnsignedDocs().then(res => {
      this.documents = res;
    });
  },
  methods: {
    ...mapActions("document", ["loadUnsignedDocs"]),
    showMore() {
      this.displayDocNumber += 4;
    },
    downloadDoc(id, fileName) {
      DocumentService.downloadUnsignedDocs(id).then(res => {
        const blob = new Blob([res.data], { type: "application/pdf" });

        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName + ".pdf");
        } else {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName + ".pdf";
          document.body.appendChild(a);
          a.click();

          setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 300);
        }
      });
    }
  }
};
</script>
<style>
.btn {
  white-space: nowrap;
}
@media (min-width: 1024px) {
  .document-list > div {
    width: 49%;
  }
}
</style>
